import { render, staticRenderFns } from "./ed-create-blocks-modal.component.vue?vue&type=template&id=0bcbc5e3&scoped=true&"
import script from "./ed-create-blocks-modal.component.ts?vue&type=script&lang=ts&"
export * from "./ed-create-blocks-modal.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-create-blocks-modal.component.scss?vue&type=style&index=0&id=0bcbc5e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcbc5e3",
  null
  
)

export default component.exports